import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import i18n from './plugins/i18n'
import { createAnalyticsPlugin } from './plugins/analytics'

// Warmup backend immediately on page load (fire and forget)
// This helps reduce Cloud Run cold start latency by waking the server
// before the user attempts to login
import { warmupBackend } from './utils/warmup'
warmupBackend()

// Styles
import './assets/styles/main.css'
// Scoped ChamberedIn-aligned palette for The Raise Room surfaces.
// Only applies inside a `.ci-theme` wrapper; the CRM keeps Mavriq gold.
import './assets/styles/network-theme.css'

// Create Vue app
const app = createApp(App)

// Use plugins
app.use(createPinia())
app.use(router)
app.use(i18n)
app.use(createAnalyticsPlugin(router))

// Mount app
app.mount('#app')
